import { Spin } from "antd";
import classNames from "classnames";
import { memo } from "react";

function MenuItem({ className, loading, active, label, icon, ...props }) {
  return (
    <div title={label} className={classNames("list-menu", className, { active })} {...props}>
      <Spin spinning={!!loading}>
        <div>{icon}</div>
        <p>{label}</p>
      </Spin>
    </div>
  );
}

export default memo(MenuItem);
